import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';

import { Button } from 'app/dialogs/dialog-buttons.component';
import { ErrorDialogComponent
       } from 'app/dialogs/error-dialog/error-dialog.component';
import { CriticalError } from './error';
import { ErrorService } from './error.service';

@Component({
  selector: 'error',
  templateUrl: './error.component.html',
  styleUrls: [ './error.component.scss' ]
})
export class ErrorComponent implements OnDestroy
{
  private errorService: ErrorService;
  public criticalError: CriticalError;

  public constructor(
      private dialog: MatDialog,
      @Inject(ErrorService) errorService: ErrorService
  )
  {
    this.errorService = errorService;

    this.errorService.errorsOccurred.subscribe((errors) => {
      let config = new MatDialogConfig;
      const closeable = errors.every(e => e.closeable());
      config.data = {
        errors: errors,
        buttons: closeable ? { primary: Button.OK } : {},
        panelClass: 'dialog-pane',
      };
      config.disableClose = !closeable;
      this.dialog.open(ErrorDialogComponent, config);
    });

    this.errorService.criticalErrorOccurred.subscribe((criticalError) => {
      this.criticalError = criticalError;
    });
  }

  public ngOnDestroy(): void
  {
    this.errorService.errorsOccurred.unsubscribe();
    this.errorService.criticalErrorOccurred.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/error/error.component.ts